import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import { concatenateObj } from '../../utils/concatenateIObj';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';
import * as ORIGINAL_HREF from '../../constants/originalHref';
import HelloSign from 'hellosign-embedded';
import * as CLIENT_ID from '../../constants/helloSignClientId';
import dayjs from 'dayjs';
import _ from 'lodash';
const firebaseRef = firebase.database();

export default async function signExtraDocument(
	formInfo, //dynamic data from from database related to the form
	formatedFormData, //data got from the form
	leadId, //the lead id
	clientInfo, //the specific client's information
	secondClient, // if there is a secondClient
	callback
) {
	console.log('signExtraDocument formData', formatedFormData);

	console.log('signExtraDocument formInfo 1', formInfo);
	console.log('signExtraDocument clientInfo', clientInfo);

	var defaultFormFields = {};

	// save client email
	var clientEmail = formatedFormData?.client_email || clientInfo.clientEmail;
	var clientFullName =
		formatedFormData?.buyer_full_name ||
		clientInfo.clientFName + ' ' + clientInfo.clientLName;

	// remove ignore===true field
	let formData = removeUnnecessaryFields(
		formatedFormData,
		formInfo?.formItems
	);

	//getting the autofilled form fields
	formInfo?.formItems?.forEach((item) => {
		if (item.tryAutoFill === true && !item?.ignore) {
			var fieldName = item.customField;
			var path = item.autoFillInfo;
			var data;

			if (path?.length > 0) {
				var pathKeys = Object.keys(path);
				var pathValue;
				var pathValuesArr = [];

				pathKeys.forEach((key) => {
					console.log('keyyy', path[key]);
					firebaseRef
						.ref(
							'/kavtek_agreements/' +
								PROJECT_CODE.projectCode +
								'/' +
								leadId +
								'/' +
								path[key]
						)
						.once('value', (snapshot) => {
							console.log(
								'getFormFieldInfo snapshot val',
								snapshot.val()
							);
							pathValue = snapshot.val();
							pathValuesArr.push(pathValue);
						});
				});

				console.log('pathvalue w/out del', pathValuesArr.join(' '));

				data = pathValuesArr.join(' ');

				if (
					item.useAddition !== undefined &&
					item.useAddition === true
				) {
					var dataVal = 0;
					pathValuesArr.forEach((newVal) => {
						dataVal = dataVal + parseFloat(newVal);
					});

					var data = new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: 'USD',
					}).format(dataVal);
				}
			} else {
				firebaseRef
					.ref(
						'/kavtek_agreements/' +
							PROJECT_CODE.projectCode +
							'/' +
							leadId +
							'/' +
							path
					)
					.once('value', (snapshot) => {
						console.log(
							'getFormFieldInfo snapshot val',
							snapshot.val()
						);
						data = snapshot.val();
					});
			}

			defaultFormFields = {
				...defaultFormFields,
				[fieldName]: data,
			};
		} else if (item?.addToDate === true) {
			var fieldName = item.customField;
			console.log('ADD TO DATE IS TRUE');
			var data;
			var signatureTimestamp;
			firebaseRef
				.ref(
					'/kavtek_agreements/' +
						PROJECT_CODE.projectCode +
						'/' +
						leadId +
						'/documentInformation/signatureRequests'
				)
				.once('value', (snapshot) => {
					console.log(
						'getFormFieldInfo snapshot val',
						snapshot.val()
					);
					var snap = snapshot.val();

					var snapKeys = Object.keys(snap);

					var apsSig = snap[snapKeys[0]];

					var sigUpdates = apsSig['signatureUpdates'];

					var sigUpdateKeys = Object.keys(sigUpdates);

					sigUpdateKeys.forEach((sigKey) => {
						var mySignature =
							sigUpdates[sigKey]['signature_request'][
								'signatures'
							][0];

						if (mySignature['status_code'] === 'signed') {
							signatureTimestamp = mySignature['signed_at'];
						}
					});
					console.log(signatureTimestamp);

					// var dateSet = dayjs(
					// 	dayjs(apsFirstDate * 1000).unix() * 1000 +
					// 		86400000 * addExtraDays
					// ).format('DD MMM YYYY');

					//data = dayjs(signatureTimestamp).add(value, 'd');
					var dataToReturn = dayjs(
						dayjs(signatureTimestamp * 1000).unix() * 1000 +
							86400000 * item.value
					).format('DD MMM YYYY');
					console.log('RETURNED DATE ' + dataToReturn.toString());

					data = dataToReturn.toString();
				});

			defaultFormFields = {
				...defaultFormFields,
				[fieldName]: data,
			};
		}
	});

	var customFields = turnCustomFieldToHelloSign(
		concatenateObj(defaultFormFields, formData)
	);

	console.log('sign extra doc customfields', customFields);
	var authToken = ORIGINAL_HREF.originalHREF['access_token'];
	var currentUserEmail = firebase.auth().currentUser.email;
	var subjectName = formInfo.subjectName;
	var message = formInfo.message;
	var projectCode = PROJECT_CODE.projectCode;
	var templateId = formInfo.templateId;
	// var clientEmail = clientInfo.clientEmail;
	// var clientFullName = clientInfo.clientFName + ' ' + clientInfo.clientLName;

	const helloClient = new HelloSign();
	var getDoc = firebase.functions().httpsCallable('HelloSignCallDocument');

	var jsonInfo = {
		authToken: authToken,
		senderEmail: currentUserEmail,
		subjectName: subjectName,
		message: message,
		projectCode: projectCode,
		templateId: templateId,
		clientEmail: clientEmail,
		clienFullName: clientFullName,
		customFields: customFields,
		overideMetaData: true,
		newMetaData: { project_code: projectCode, leadId: leadId },
	};

	var newSignersArray = [];

	var overidesRoles = formInfo?.overideRoles;

	if (overidesRoles !== undefined) {
		var newSigners;
		var overidesRolesKeys = overidesRoles && Object.keys(overidesRoles);

		overidesRolesKeys &&
			overidesRolesKeys?.forEach((key) => {
				console.log('overidesRolesKeys keys', overidesRoles[key]);
				if (overidesRoles[key]['findName'] === true) {
					var nameTitle = overidesRoles[key]['name'];
					var emailTitle = overidesRoles[key]['email_field'];
					var role = overidesRoles[key]['role'];

					var name = customFields.find(
						(item) => item.name === nameTitle
					)?.value;

					var email = customFields.find(
						(item) => item.name === emailTitle
					)?.value;

					console.log('overide roles name 234123', name);

					newSigners = {
						...newSigners,
						name: name,
						email_address: email,
						role: role,
					};

					newSignersArray.push(newSigners);
				} else {
					var name = overidesRoles[key]['name'];
					var email = overidesRoles[key]['email_address'];
					var role = overidesRoles[key]['role'];

					newSigners = {
						...newSigners,
						name: name,
						email_address: email,
						role: role,
					};

					newSignersArray.push(newSigners);
				}
			});

		console.log('newSignersArray', newSignersArray);

		jsonInfo['newSigners'] = newSignersArray;
		jsonInfo['overideSigners'] = true;
		jsonInfo['overideMetaData'] = true;
		jsonInfo['newMetaData'] = {
			my_client: clientEmail,
			project_code: projectCode,
			leadId: leadId,
		};
	}

	console.log('new json info ', jsonInfo);
	////// second client
	let secondPurchaserTemplateId = formInfo?.secondPurchaserTemplateId;
	if (secondClient && secondPurchaserTemplateId) {
		jsonInfo['secondClientFullName'] = secondClient.secondClientFullName;
		jsonInfo['secondClientEmail'] = secondClient?.secondClientEmail;
		jsonInfo['templateId'] = secondPurchaserTemplateId;
		getDoc = firebase
			.functions()
			.httpsCallable('HelloSignCallDocumentSecondPurchaser');
		let secondfFullNameJson = {
			name: 'second_full_name',
			value: secondClient.secondClientFullName,
		};
		jsonInfo.customFields.push(secondfFullNameJson);
	}
	//////
	var finishedData;

	const displayHelloDoc = (signUrl) => {
		console.log('signurl: ' + signUrl);
		helloClient.open(signUrl, {
			skipDomainVerification: true,
			clientId: CLIENT_ID.clientId,
		});
	};

	helloClient.on('finish', () => {
		SaveClientSignatureRequestInfoExtras(finishedData, subjectName, leadId);
		callback(true);
	});

	getDoc(jsonInfo)
		.then((result) => {
			displayHelloDoc(result['data']['claim_url']);

			finishedData = result['data'];
		})
		.catch(function (error) {
			console.error('Error ', error);
		});
}

export const turnCustomFieldToHelloSign = (customFields) => {
	var finalCustom = [];

	var allKeys = Object.keys(customFields);

	console.log('turnCustomFieldToHelloSign allKeys: ', allKeys);

	allKeys.forEach((key) => {
		var newJson = {
			name: key,
			value: customFields[key],
		};

		finalCustom.push(newJson);
	});

	console.log('turnCustomFieldToHelloSign finalCustom: ', finalCustom);

	return finalCustom;
};

export async function SaveClientSignatureRequestInfoExtras(
	unclaimedDraftJson,
	subjectName,
	leadId
) {
	console.log('saveOrUpdateDocument');

	var clientSignatureRef = firebase
		.database()
		.ref(
			'/kavtek_agreements/' +
				PROJECT_CODE.projectCode +
				'/' +
				leadId +
				'/documentInformation/signatureRequestsExtras'
		);

	var newSignatureRequest = clientSignatureRef.push();

	unclaimedDraftJson['timestamp'] = Date.now();
	unclaimedDraftJson['subject'] = subjectName;

	newSignatureRequest.set(unclaimedDraftJson);
}

const removeUnnecessaryFields = (forms, formItems) => {
	let formObjs = forms;
	// remove unnecessary fields
	_.filter(formItems, function (item) {
		let key = item?.customField;
		if (item?.ignore === true) {
			delete formObjs?.[key];
		}
	});

	// check agent_name is object or string ?
	let agentName =
		formObjs?.agent_name?.salesAgentName || formObjs?.agent_name?.name;
	if (agentName) {
		formObjs = Object.assign(formObjs, {
			agent_name: agentName,
		});
	}
	return formObjs;
};
